import { useContext } from "react";
import { FeaturesContext } from "../contexts/features.context";
import { useFeatureFlagEnabled } from 'posthog-js/react'

const useFeatures = (name) => {
  const enabled = useFeatureFlagEnabled(name)
  return enabled
}

export default useFeatures;